export interface ReplayFrame {
  t: number;
  throttle: number;
  brake: number;
  steer: number;
}

export interface ReplayRecorder {
  recording: boolean;
  frames: ReplayFrame[];
}

export function createReplayRecorder(): ReplayRecorder {
  return {
    recording: false,
    frames: [],
  };
}
